'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdExtension = function MdExtension(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 18.4c2.3 0 4.3 1.8 4.3 4.1s-2 4.1-4.3 4.1h-2.5v6.8c0 1.8-1.4 3.2-3.2 3.2h-6.4v-2.5c0-2.5-2-4.4-4.5-4.4s-4.5 1.9-4.5 4.4v2.5h-6.4c-1.8 0-3.2-1.4-3.2-3.2v-6.4h2.5c2.5 0 4.4-2 4.4-4.5s-1.9-4.5-4.4-4.5h-2.5v-6.4c0-1.8 1.4-3.2 3.2-3.2h6.8v-2.5c0-2.3 1.8-4.3 4.1-4.3s4.1 2 4.1 4.3v2.5h6.8c1.8 0 3.2 1.4 3.2 3.2v6.8h2.5z' })
        )
    );
};

exports.default = MdExtension;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/extension.js
// module id = 3050
// module chunks = 0